import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import GlobalSettings from "../../WidgetsSettings/GlobalSettings/GlobalSettingsModal";

import { SummariesSettings } from "./SummariesSettings";
import "../../WidgetsSettings/GlobalSettings/GlobalSettings.less";
import "./ListSummariesModal.less";
import { ListSettings } from "./ListSettings";
import { useIntl } from "react-intl";
import SectionSettings from "../../WidgetsSettings/SectionWidget/SectionSettings";
import { SummariesValue } from "../types";

type ListSummariesModalProps = {
   value: SummariesValue;
   optionsForBenefitSlides: Array<{ value: string; label: string }>;
   sumsFromBenefits: Record<string, number>;
   data: any;
};

export const ListSummariesModal = ({
   value,
   optionsForBenefitSlides,
   sumsFromBenefits,
   data,
}: ListSummariesModalProps) => {
   const intl = useIntl();

   return (
      <Tabs defaultActiveKey="globalSettings">
         <TabPane tab={intl.formatMessage({ id: "settings.widgetSettings" })} key="globalSettings">
            <GlobalSettings value={value} />
         </TabPane>
         <TabPane tab={intl.formatMessage({ id: "settings.titleSettings" })} key="titleSettings">
            <SectionSettings value={value} data={data} />
         </TabPane>
         <TabPane tab={intl.formatMessage({ id: "settings.listSettings" })} key="listSettings">
            <ListSettings value={value} />
         </TabPane>
         {value?.mode !== "external" && (
            <TabPane
               tab={intl.formatMessage({ id: "settings.listSummariesSettings" })}
               key="listSummariesSettings"
            >
               <SummariesSettings
                  value={value}
                  opts={optionsForBenefitSlides}
                  sumsFromBenefits={sumsFromBenefits}
               />
            </TabPane>
         )}
      </Tabs>
   );
};
